import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const basic: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[100]};
`;
